import React, { useMemo, useState } from "react";
import { AuthFrame } from "../components/AuthFrame.jsx";
import { postJson, responseMessage } from "../lib/api.js";
import { getRecaptchaToken } from "../lib/recaptcha.js";

export function ResetPasswordPage() {
  const params = useMemo(() => new URLSearchParams(window.location.search), []);
  const token = params.get("token") || "";
  const email = params.get("email") || "";
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState(!token || !email ? "Invalid reset link parameters. Please request a new link." : "");
  const [complete, setComplete] = useState(false);

  async function handleSubmit(event) {
    event.preventDefault();
    const fields = new FormData(event.currentTarget);
    const newPassword = String(fields.get("newPassword") || "");
    const confirmPassword = String(fields.get("confirmPassword") || "");

    if (newPassword !== confirmPassword) {
      setError("Passwords do not match.");
      return;
    }
    if (!token || !email) {
      setError("Invalid reset link parameters. Please request a new link.");
      return;
    }

    setBusy(true);
    setError("");
    try {
      const recaptchaToken = await getRecaptchaToken("reset_password");
      const { response, data } = await postJson("/api/Auth/reset-password", {
        email,
        token,
        newPassword,
        recaptchaToken: recaptchaToken || "skip"
      });
      if (!response.ok) throw new Error(responseMessage(data, "Failed to reset password."));
      setComplete(true);
    } catch (submitError) {
      setError(submitError.message || "Network error. Please try again.");
    } finally {
      setBusy(false);
    }
  }

  if (complete) {
    return (
      <AuthFrame title="Password Reset!" subtitle="Your password has been changed successfully.">
        <a className="auth-primary-btn react-link-button" href="/Account/Login">Return to Login</a>
      </AuthFrame>
    );
  }

  return (
    <AuthFrame title="Choose a new password" subtitle="Enter and confirm the new password for your account.">
      <form className="login-form" onSubmit={handleSubmit}>
        <div className="auth-field">
          <label htmlFor="resetEmailDisplay">Email address</label>
          <input id="resetEmailDisplay" value={email} readOnly />
        </div>
        <div className="auth-field">
          <label htmlFor="resetNewPass">New password</label>
          <input id="resetNewPass" name="newPassword" type="password" minLength="6" autoComplete="new-password" required />
        </div>
        <div className="auth-field">
          <label htmlFor="resetNewPassConf">Confirm new password</label>
          <input id="resetNewPassConf" name="confirmPassword" type="password" minLength="6" autoComplete="new-password" required />
        </div>
        {error && <div className="auth-error" role="alert">{error}</div>}
        <button className="auth-primary-btn" disabled={busy || !token || !email} type="submit">
          {busy ? "Resetting..." : "Reset Password"}
        </button>
      </form>
    </AuthFrame>
  );
}
